// Summary mini card
const MiniStat = ({ value, label, color }) => (
  <div
    style={{
      background: color,
      borderRadius: '12px',
      padding: '21px 18px',
      textAlign: 'center',
      flex: '1 1 80px',
    }}
  >
    <div style={{ fontSize: '28px', fontWeight: '800', color: '#fff', lineHeight: 1 }}>{value}</div>
    <div style={{ fontSize: '14px', color: '#fff', opacity: 0.9, marginTop: '4px', fontWeight: '500' }}>{label}</div>
  </div>
);

export default MiniStat;
